import { Link } from "react-router-dom";
import { useState } from "react";
import { toast } from "sonner";
import { SITE, NAV_LINKS } from "../../lib/content";
import api from "../../lib/api";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const { data } = await api.post("/newsletter", { email });
      toast.success(data.message || "Subscribed.");
      setEmail("");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(
        typeof detail === "string"
          ? detail
          : "Could not subscribe. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0F172A] text-cream mt-32"
    >
      <div className="container-vk py-20 md:py-28">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-6">
            <p className="overline text-gold mb-6">Stay in the conversation</p>
            <h2 className="heading-display text-4xl sm:text-5xl lg:text-6xl font-semibold leading-[1.05] text-balance">
              New books, dispatches and speaking dates — sent occasionally.
            </h2>
            <form
              onSubmit={subscribe}
              className="mt-10 flex flex-col sm:flex-row gap-3 max-w-xl"
              data-testid="footer-newsletter-form"
            >
              <input
                type="email"
                required
                placeholder="your@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="footer-newsletter-email"
                className="flex-1 bg-transparent border border-cream/30 focus:border-gold outline-none px-5 py-4 text-cream placeholder:text-cream/50"
              />
              <button
                type="submit"
                disabled={loading}
                data-testid="footer-newsletter-submit"
                className="bg-cream text-ink px-7 py-4 font-medium hover:bg-gold hover:text-ink transition-colors disabled:opacity-60"
              >
                {loading ? "Subscribing…" : "Subscribe"}
              </button>
            </form>
          </div>

          <div className="lg:col-span-3 lg:col-start-8">
            <p className="overline text-gold mb-5">Explore</p>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.label.toLowerCase()}`}
                    className="link-underline text-cream/85 hover:text-gold text-base"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <p className="overline text-gold mb-5">Contact</p>
            <p className="text-cream/85 mb-2">{SITE.email}</p>
            <p className="text-cream/60 text-sm">{SITE.location}</p>
            <div className="mt-8">
              <Link
                to="/admin/login"
                data-testid="footer-admin-link"
                className="text-xs uppercase tracking-[0.22em] text-cream/40 hover:text-gold"
              >
                Admin
              </Link>
            </div>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-cream/15 flex flex-col sm:flex-row justify-between gap-4 text-sm text-cream/55">
          <p>© {new Date().getFullYear()} Victor Kwawukume. All rights reserved.</p>
          <p className="font-serif italic">
            From Accra's corridors of power to Canada's frontline wards.
          </p>
        </div>
      </div>
    </footer>
  );
}
